import React from "react";
import AppButton from "../AppButton/app_button";
import "./BillingPausedPaywall.css";

export type BillingPausedPaywallProps = {
  opening?: boolean;
  onPayOutstanding: () => void;
  className?: string;
};

/**
 * Shared frozen-account CTA (Premium + write-entry gates).
 * @param {BillingPausedPaywallProps} props
 * @returns {React.ReactElement}
 */
const BillingPausedPaywall: React.FC<BillingPausedPaywallProps> = ({
  opening = false,
  onPayOutstanding,
  className,
}) => (
  <div className={className ?? "billing-paused-paywall"}>
    <div className="billing-paused-paywall__card">
      <h2 className="billing-paused-paywall__title">
        Billing{" "}
        <span className="billing-paused-paywall__title-brand">paused</span>
      </h2>
      <p className="billing-paused-paywall__description">
        A previous invoice is unpaid. Pay it on the same Stripe subscription —
        do not start a new checkout. Update your card and pay outstanding
        invoices in Billing.
      </p>
      <AppButton
        className="billing-paused-paywall__btn"
        disabled={opening}
        onClick={onPayOutstanding}
      >
        {opening ? "Opening…" : "Pay outstanding invoice"}
      </AppButton>
    </div>
  </div>
);

export default BillingPausedPaywall;
